<template>
  <div>
    <a href="https://www.tucsonpathways.org"><div id="logo">Tp</div></a>
    <!-- <button
      @click="calcStats"
      style="position:absolute; top:60px; left:30px; z-index:3"
    >
      <p>stats</p>
    </button> -->
    <!-- <Statistics
      :markerList="markerList"
      :localMapIsStatic="localMapIsStatic"
      :refreshStats="refreshStats"
    /> -->
    <div ref="mapboxMap" id="mapboxCanvas" />

    <template v-if="mapIsReady">
      <slot :map="map" />
    </template>
    <TurfCircles
      :refreshStats="refreshStats"
      :markerList="markerList"
      @toggleTurfCirclesBoolean="toggleTurfCirclesBoolean"
    />
    <HudSwiper
      v-on="$listeners"
      :markerList="markerList"
      :localMapIsStatic="localMapIsStatic"
      :refreshStats="refreshStats"
      @toggleRefreshStats="toggleRefreshStats"
      @dropFarmMarkers="dropFarmMarkers"
      @dropVolunteerMarkers="dropVolunteerMarkers"
      @dropBikeShopMarkers="dropBikeShopMarkers"
      @dropMuseumMarkers="dropMuseumMarkers"
      @dropBarMarkers="dropBarMarkers"
      @dropRestaurantMarkers="dropRestaurantMarkers"
      @dropBreweryMarkers="dropBreweryMarkers"
      @dropCoffeeMarkers="dropCoffeeMarkers"
      @toggleSafeRouting="toggleSafeRouting"
    />
    <MyStaticHud
      @toggleSafeRouting="toggleSafeRouting"
      :geocoderData="geocoderData"
      @directionsSearched="searchedDirections"
      :currentMarker="currentMarker"
      :localMapIsStatic="localMapIsStatic"
      :hudCenter="mapCenterRounded"
      :hudZoom="mapZoomRounded"
      :markerList="markerList"
      @toggleCrosshair="toggleCrosshair"
      @toggleFreeDrawMode="toggleFreeDrawMode"
      @hudDropMarker="mapDropMarker"
      @undoLastMarker="undoLastMarker"
    />
  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

// Note: featureCollection is part of the @turf/helpers module.
// To use it as a stand-alone module will need to import @turf/helpers and call the featureCollection method.
import * as turf from "@turf/helpers";
import nearestPoint from "@turf/nearest-point";

//Mapbox Stuff
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl"; // or "const mapboxgl = require('mapbox-gl');"
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import HudSwiper from "@/components/HudSwiper.vue";

//Vue Components
import MyStaticHud from "./MyStaticHud.vue"; // import MyStaticHud from "@/components/MyStaticHud.vue";
import TurfCircles from "./TurfCircles.vue";
import { mapState } from "vuex";
// import Routing from "./Routing.vue"; // import MyStaticHud from "@/components/MyStaticHud.vue";

//Graphhopper Stuff
require("graphhopper-js-api-client");
var GraphHopper = require("graphhopper-js-api-client/src/GraphHopperRouting"); // If you only need e.g. Routing, you can only require the needed parts
var GHInput = require("graphhopper-js-api-client/src/GHInput");

//Fetch Function
// const fetch = require("node-fetch");

//Import Yelp Jsons Until I relocate them to Express Server
import coffee from "@/yelp/coffee.json";
import museums from "@/yelp/museums.json";
import bikeshops from "@/yelp/bikeshops.json";
import breweries from "@/yelp/breweries.json";
import bars from "@/yelp/bars.json";
import restaurants from "@/yelp/restaurants.json";
import farmersmarket from "@/yelp/farmersmarket.json";
// import parks from "@/assets/parks.json";

export default {
  name: "StaticMap",
  components: {
    MyStaticHud,
    TurfCircles,
    HudSwiper
  },
  mounted() {
    this.initializeMap();
  },
  data() {
    return {
      defaults: {
        key: "7bca7e42-39c5-4e81-bb5d-bbc3c05ae5ed", //"a90c4fb4-008d-40e7-af66-03bb26580953",
        // host: host,
        vehicle: "bike",
        elevation: false
        //profile: "bike",
      },
      geolocate: null,
      geolocateMarker: null,
      geolocatePosition: {
        lng: null,
        lat: null
      },
      geolocateSettings: {
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      },
      geocoder: null,
      geocoderData: {
        locationName: "",
        active: false
      },
      ghRouting: null,
      GHParameters: {
        safe: {
          profile: "pathways1",
          host: "https://neighborhoodpathways.org", //host: "http://localhost:8989",
          details: ["road_class", "distance"]
        },
        risky: {
          profile: "pathways6",
          host: "https://neighborhoodpathways.org", //host: "http://localhost:8989",
          details: ["road_class", "distance"]
        },
        co2: {
          profile: "co2car",
          host: "https://neighborhoodpathways.org", //host: "http://localhost:8989",
          details: ["road_class", "distance"]
        }
      },
      map: null,
      mapIsReady: false,
      mapCenter: { lng: -110.92, lat: 32.22 },
      mapZoom: 12.826,
      centerdot: null,
      mapboxAPIKey:
        "pk.eyJ1IjoiZHlsYW5jIiwiYSI6Im53UGgtaVEifQ.RJiPqXwEtCLTLl-Vmd1GWQ",
      uniquePOIKey: 0,
      markerList: [],
      localMapIsStatic: true,
      currentMarker: "",
      refreshStats: false,
      refreshTurfCicles: false,
      zoomed: false,
      insideWarningBubble: false
    };
  },
  computed: {
    ...mapState(["mapMode", "uiRouteType", "activeLayers", "activeBaseLayers"]),
    linecolor() {
      if (this.uiRouteType == "Safe" && !this.activeBaseLayers.streetlights) {
        return "#1c4358";
      } else if (
        this.uiRouteType == "Traditional" &&
        !this.activeBaseLayers.streetlights
      ) {
        return "#a05121";
      } else if (
        this.uiRouteType == "Safe" &&
        this.activeBaseLayers.streetlights
      ) {
        return "white";
      } else if (
        this.uiRouteType == "Traditional" &&
        this.activeBaseLayers.streetlights
      ) {
        return "#a05121";
      } else {
        return "#1c4358";
      }
    },
    pathways() {
      return this.activeBaseLayers.pathways;
    },
    highstress() {
      return this.activeBaseLayers.highstress;
    },
    lowstress() {
      return this.activeBaseLayers.lowstress;
    },
    hawks() {
      return this.activeBaseLayers.hawks;
    },
    bikelanes() {
      return this.activeBaseLayers.bikelanes;
    },
    theloop() {
      return this.activeBaseLayers.theloop;
    },
    satellite() {
      return this.activeBaseLayers.satellite;
    },
    annotations() {
      return this.activeBaseLayers.annotations;
    },
    streetlights() {
      return this.activeBaseLayers.streetlights;
    },
    numberOfMarkers() {
      return this.markerList.length;
    },
    // Remember, alternatively to ...mapState(["mbglCenter"]) another way to bring one store data value being brought into a component would be just using a computed value such as >>> mbglCenter() {return this.$store.state.mbglCenter}
    mapCenterRounded() {
      return [
        Math.round(this.mapCenter.lng * 1000) / 1000,
        Math.round(this.mapCenter.lat * 1000) / 1000
      ];
    },
    mapZoomRounded() {
      return Math.round(this.mapZoom * 100) / 100;
    }
  },
  watch: {
    refreshTurfCicles() {
      this.removeAllCirclesOnMap();
      this.updateAllTurfCircles();
      console.log("hi");
    },
    pathways() {
      let array = ["tnr-v9-7p9y6s", "tnr-v9-7p9y6s copy"];
      if (this.pathways) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    highstress() {
      let array = ["hs-v2-7bxiun", "hs-v2-7bxiun copy"];
      if (this.highstress) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    lowstress() {
      let array = ["ls-v3-cj14ge", "ls-v3-cj14ge copy 1"];
      if (this.lowstress) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    hawks() {
      let array = ["hawks-v2-bb9wvv"];
      if (this.hawks) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    bikelanes() {
      let array = ["osm-bicycleinfras"];
      if (this.bikelanes) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    theloop() {
      let array = ["theloop-b2gq5f"];
      if (this.theloop) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    satellite() {
      let array = ["mapbox-satellite"];
      if (this.satellite) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    annotations() {
      let array = [
        "country-label",
        "state-label",
        "settlement-subdivision-label",
        "airport-label",
        "poi-label",
        "water-point-label",
        "water-line-label",
        "natural-point-label",
        "natural-line-label",
        "waterway-label",
        "road-label",
        "hawks-v2-bb9wvv copy"
      ];
      if (this.annotations) {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "visible");
        });
      } else {
        array.forEach(layer => {
          this.map.setLayoutProperty(layer, "visibility", "none");
        });
      }
    },
    streetlights() {
      if (this.streetlights) {
        for (let j = 1; j <= this.markerList.length - 1; j++) {
          this.map.setPaintProperty(
            this.markerList[j].id,
            "line-color",
            "white"
          );
        }

        let nightRoad = "#3d3d3d";
        let nightRoadCase = "#242424";
        let nightTunnelCase = "#454545";
        let nightWater = "#1f1f1f";
        let nightWaterShadow = "#050505";
        let nightAeroway = "#404040";
        let nightLand = "#292929";
        let nightParks = "#252727";
        // let nightBuildings = "#2b2b2b"; not used
        let nightLandCover = "#282929";
        //TNR Layers
        let nightTNR = "#737168";
        let nightHawks = "#d7af65"; //'white'//'#d7af65';
        let nightHawksCase = "black"; //'#292929';

        //Set color of default layers
        this.map.setPaintProperty(
          "road-motorway-trunk",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty("road-primary", "line-color", nightRoad);
        this.map.setPaintProperty(
          "road-secondary-tertiary",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty("road-street", "line-color", nightRoad);
        this.map.setPaintProperty("road-minor", "line-color", nightRoad);
        this.map.setPaintProperty("road-major-link", "line-color", nightRoad);
        this.map.setPaintProperty("road-construction", "line-color", nightRoad);
        this.map.setPaintProperty(
          "road-motorway-trunk-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "road-major-link-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "road-primary-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "road-secondary-tertiary-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "road-street-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty("road-street-low", "line-color", nightRoad);
        this.map.setPaintProperty(
          "road-minor-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty("road-minor-low", "line-color", nightRoad);

        this.map.setPaintProperty("bridge-rail", "line-color", nightRoad);
        this.map.setPaintProperty("road-rail", "line-color", nightRoad);

        this.map.setPaintProperty(
          "tunnel-motorway-trunk",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-primary-secondary-tertiary",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-major-link",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-motorway-trunk-case",
          "line-color",
          nightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-major-link-case",
          "line-color",
          nightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-primary-secondary-tertiary-case",
          "line-color",
          nightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor-case",
          "line-color",
          nightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor-low",
          "line-color",
          nightRoadCase
        );

        this.map.setPaintProperty(
          "bridge-motorway-trunk-2",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty(
          "bridge-major-link-2",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk-2-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-major-link-2-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty(
          "bridge-primary-secondary-tertiary",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty(
          "bridge-street-minor",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty("bridge-major-link", "line-color", nightRoad);
        this.map.setPaintProperty(
          "bridge-construction",
          "line-color",
          nightRoad
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-major-link-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-primary-secondary-tertiary-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-street-minor-case",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-street-minor-low",
          "line-color",
          nightRoad
        );

        this.map.setPaintProperty("aeroway-line", "line-color", nightAeroway);
        this.map.setPaintProperty(
          "aeroway-polygon",
          "fill-color",
          nightAeroway
        );
        this.map.setPaintProperty(
          "land-structure-line",
          "line-color",
          nightLand
        );
        this.map.setPaintProperty(
          "land-structure-polygon",
          "fill-color",
          nightLand
        );

        this.map.setPaintProperty("water", "fill-color", nightWater);
        this.map.setPaintProperty("waterway", "line-color", nightWater);
        this.map.setPaintProperty(
          "water-shadow",
          "fill-color",
          nightWaterShadow
        );
        this.map.setPaintProperty(
          "waterway-shadow",
          "line-color",
          nightWaterShadow
        );

        this.map.setPaintProperty("landuse", "fill-color", nightParks);
        this.map.setPaintProperty("national-park", "fill-color", nightParks);
        this.map.setPaintProperty("landcover", "fill-color", nightLandCover);
        this.map.setPaintProperty("land", "background-color", nightLand);

        //Sec color of TNR layers
        this.map.setPaintProperty("tnr-v9-7p9y6s copy", "line-color", nightTNR);
        this.map.setPaintProperty("tnr-v9-7p9y6s", "line-color", nightRoadCase);
        this.map.setPaintProperty(
          "hawks-v2-bb9wvv",
          "circle-color",
          nightHawks
        );
        this.map.setPaintProperty(
          "hawks-v2-bb9wvv",
          "circle-stroke-color",
          nightHawksCase
        );
        this.map.setPaintProperty(
          "lshs-hawkroads-v2-ddpdin copy 1",
          "line-color",
          nightTNR
        );
        this.map.setPaintProperty(
          "lshs-hawkroads-v2-ddpdin",
          "line-color",
          nightRoadCase
        );
        this.map.setPaintProperty("hs-v2-7bxiun copy", "line-color", nightTNR);
        this.map.setPaintProperty(
          "ls-v3-cj14ge copy 1",
          "line-color",
          nightTNR
        );

        //Add Streetlights
        this.map.setLayoutProperty(
          "ls-streetlights-4od5h2",
          "visibility",
          "visible"
        );
        this.map.setLayoutProperty(
          "ls-streetlights-4od5h2 copy",
          "visibility",
          "visible"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j",
          "visibility",
          "visible"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy",
          "visibility",
          "visible"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy 1",
          "visibility",
          "visible"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy 2",
          "visibility",
          "visible"
        );

        //Hide TP Roads, but Keep Hawks on
        // this.map.setLayoutProperty("tnr-v9-7p9y6s copy", "visibility", "none");
        // this.map.setLayoutProperty("tnr-v9-7p9y6s", "visibility", "none");
        // this.map.setLayoutProperty(
        //   "lshs-hawkroads-v2-ddpdin copy 1",
        //   "visibility",
        //   "none"
        // );
        // this.map.setLayoutProperty("lshs-hawkroads-v2-ddpdin", "visibility", "none");
        // this.map.setLayoutProperty('hawks-v2-bb9wvv', 'visibility', 'none');

        //Remove all Cul-de-sacs because of that bug where for some reason I cannot change their color (not even in mapbox studio)
        this.map.setLayoutProperty("turning-feature", "visibility", "none");
        this.map.setLayoutProperty(
          "turning-feature-outline",
          "visibility",
          "none"
        );
      } else {
        //Set daytime colors
        //Default Map Layers

        for (let j = 1; j <= this.markerList.length - 1; j++) {
          this.map.setPaintProperty(
            this.markerList[j].id,
            "line-color",
            this.linecolor
          );
        }

        let lightRoad = "#ffffff";
        let lightRoadCase = "#d9d9d9";
        let lightTunnelCase = "#e0e6e6";
        let lightWater = "#cad2d3";
        let lightWaterShadow = "#b5bebf";
        let lightAeroway = "#f7f7f7";
        let lightLand = "#f9f9f6"; //F1F3F3
        let lightParks = "#eceeed";
        // let lightBuildings = "#47484d"; not used
        let lightLandCover = "#e3e3e3";
        //TNR Layers
        let lightTNR = "#e6e6e6";
        let lightTNRCase = "#828283";
        let lightHawks = "#e4c790";
        let lightHawksStroke = "#b3b3b3";

        //Set color of default layers
        this.map.setPaintProperty(
          "road-motorway-trunk",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty("road-primary", "line-color", lightRoad);
        this.map.setPaintProperty(
          "road-secondary-tertiary",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty("road-street", "line-color", lightRoad);
        this.map.setPaintProperty("road-minor", "line-color", lightRoad);
        this.map.setPaintProperty("road-major-link", "line-color", lightRoad);
        this.map.setPaintProperty("road-construction", "line-color", lightRoad);
        this.map.setPaintProperty(
          "road-motorway-trunk-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "road-major-link-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "road-primary-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "road-secondary-tertiary-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "road-street-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty("road-street-low", "line-color", lightRoad);
        this.map.setPaintProperty(
          "road-minor-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty("road-minor-low", "line-color", lightRoad);

        this.map.setPaintProperty("bridge-rail", "line-color", lightRoad);
        this.map.setPaintProperty("road-rail", "line-color", lightRoad);

        this.map.setPaintProperty(
          "tunnel-motorway-trunk",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-primary-secondary-tertiary",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-major-link",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "tunnel-motorway-trunk-case",
          "line-color",
          lightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-major-link-case",
          "line-color",
          lightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-primary-secondary-tertiary-case",
          "line-color",
          lightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor-case",
          "line-color",
          lightTunnelCase
        );
        this.map.setPaintProperty(
          "tunnel-street-minor-low",
          "line-color",
          lightRoadCase
        );

        this.map.setPaintProperty(
          "bridge-motorway-trunk-2",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty(
          "bridge-major-link-2",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk-2-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-major-link-2-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty(
          "bridge-primary-secondary-tertiary",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty(
          "bridge-street-minor",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty("bridge-major-link", "line-color", lightRoad);
        this.map.setPaintProperty(
          "bridge-construction",
          "line-color",
          lightRoad
        );
        this.map.setPaintProperty(
          "bridge-motorway-trunk-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-major-link-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-primary-secondary-tertiary-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-street-minor-case",
          "line-color",
          lightRoadCase
        );
        this.map.setPaintProperty(
          "bridge-street-minor-low",
          "line-color",
          lightRoad
        );

        this.map.setPaintProperty("aeroway-line", "line-color", lightAeroway);
        this.map.setPaintProperty(
          "aeroway-polygon",
          "fill-color",
          lightAeroway
        );
        this.map.setPaintProperty(
          "land-structure-line",
          "line-color",
          lightLand
        );
        this.map.setPaintProperty(
          "land-structure-polygon",
          "fill-color",
          lightLand
        );

        this.map.setPaintProperty("water", "fill-color", lightWater);
        this.map.setPaintProperty("waterway", "line-color", lightWater);
        this.map.setPaintProperty(
          "water-shadow",
          "fill-color",
          lightWaterShadow
        );
        this.map.setPaintProperty(
          "waterway-shadow",
          "line-color",
          lightWaterShadow
        );

        this.map.setPaintProperty("landuse", "fill-color", lightParks);
        this.map.setPaintProperty("national-park", "fill-color", lightParks);
        this.map.setPaintProperty("landcover", "fill-color", lightLandCover);
        this.map.setPaintProperty("land", "background-color", lightLand);

        //Sec color of TNR layers
        this.map.setPaintProperty("tnr-v9-7p9y6s", "line-color", lightTNRCase);
        this.map.setPaintProperty("tnr-v9-7p9y6s copy", "line-color", lightTNR);
        this.map.setPaintProperty(
          "lshs-hawkroads-v2-ddpdin copy 1",
          "line-color",
          lightTNR
        );
        this.map.setPaintProperty(
          "lshs-hawkroads-v2-ddpdin",
          "line-color",
          lightTNRCase
        );
        this.map.setPaintProperty(
          "hawks-v2-bb9wvv",
          "circle-stroke-color",
          lightHawksStroke
        );
        this.map.setPaintProperty("hs-v2-7bxiun copy", "line-color", lightTNR);
        this.map.setPaintProperty(
          "ls-v3-cj14ge copy 1",
          "line-color",
          lightTNR
        );
        this.map.setPaintProperty(
          "hawks-v2-bb9wvv",
          "circle-color",
          lightHawks
        );

        //Remove Streetlights
        this.map.setLayoutProperty(
          "ls-streetlights-4od5h2",
          "visibility",
          "none"
        );
        this.map.setLayoutProperty(
          "ls-streetlights-4od5h2 copy",
          "visibility",
          "none"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j",
          "visibility",
          "none"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy",
          "visibility",
          "none"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy 1",
          "visibility",
          "none"
        );
        this.map.setLayoutProperty(
          "hs-streetlights-4qsd4j copy 2",
          "visibility",
          "none"
        );

        //Show TP Road Layers
        // this.map.setLayoutProperty("tnr-v9-7p9y6s copy", "visibility", "visible");
        // this.map.setLayoutProperty("tnr-v9-7p9y6s", "visibility", "visible");
        // this.map.setLayoutProperty(
        //   "lshs-hawkroads-v2-ddpdin copy 1",
        //   "visibility",
        //   "visible"
        // );
        // this.map.setLayoutProperty(
        //   "lshs-hawkroads-v2-ddpdin",
        //   "visibility",
        //   "visible"
        // );
        // this.map.setLayoutProperty('hawks-v2-bb9wvv', 'visibility', 'visible');

        //Add all Cul-de-sacs because of that bug where for some reason I cannot change their color (not even in mapbox studio)
        this.map.setLayoutProperty("turning-feature", "visibility", "visible");
        this.map.setLayoutProperty(
          "turning-feature-outline",
          "visibility",
          "visible"
        );
      }
    },
    mapMode() {
      if (this.mapMode === "freeDrawMode") {
        this.map.getCanvas().style.cursor = "crosshair";
        this.centerdot.remove();
      }
      if (this.mapMode !== "freeDrawMode") {
        this.map.getCanvas().style.cursor = "";
      }
      if (this.mapMode !== "searchMode") {
        if (this.geocoder.mapMarker) {
          this.geocoder.mapMarker.remove();
        }
      }
      if (this.mapMode !== "crosshairMode") {
        if (this.centerdot) {
          this.centerdot.remove();
        }
      }
      if (this.mapMode === "crosshairMode") {
        this.geocoder.clear();
        document.activeElement.blur(); //Removes focus from searchbar (I think)
      }
    }
  },
  methods: {
    toggleTurfCirclesBoolean() {
      this.refreshTurfCicles = !this.refreshTurfCicles;
    },
    zoomToFullRoute() {
      let boundary = [];
      let adjustment = 0.01;
      let a = this.markerList[0].getLngLat().lng;
      let b = this.markerList[0].getLngLat().lat;
      let c = this.markerList[this.markerList.length - 1].getLngLat().lng;
      let d = this.markerList[this.markerList.length - 1].getLngLat().lat;
      if (a < c) {
        a = a - adjustment;
        c = c + adjustment;
      } else {
        c = c - adjustment;
        a = a + adjustment;
      }
      if (b < d) {
        b = b - adjustment;
        d = d + adjustment;
      } else {
        b = b + adjustment;
        d = d - adjustment;
      }
      boundary = [a, b, c, d];
      this.map.fitBounds(boundary);
      // map.zoomTo(map.getZoom() - 0.5);
    },
    displaySpecificCirclesOnMap(marker) {
      setTimeout(() => {
        //Only display the source that is currently active
        let routeType = this.uiRouteType == "Safe" ? "safe" : "risky";

        this.map.addSource(
          "dangersource" + routeType + marker.id,
          marker.warning[routeType]
        );
        this.map.addLayer({
          id: "dangerdot" + routeType + marker.id,
          type: "circle",
          source: "dangersource" + routeType + marker.id,
          layout: {},
          paint: {
            "circle-color": "brown",
            "circle-opacity": 1,
            "circle-radius": {
              stops: [
                [0, 5 * Math.pow(2, 0 - 23.5)],
                [24, 5 * Math.pow(2, 24 - 23.5)]
                //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
                //set the line-width at different zooms,
                //specifically the minzoom and maxzoom. By using the exponential
                //type with base set to 2 the line width function should
                //interpolate between these zooms in a way that the line covers
                //the same geographic area as you zoom in and out.
              ]
            },
            "circle-stroke-color": "black",
            "circle-stroke-opacity": 1,
            "circle-stroke-width": 1,
            "circle-pitch-alignment": "map"
          }
        });
        //Add radial circle
        this.map.addLayer({
          id: "dangercircle" + routeType + marker.id,
          type: "circle",
          source: "dangersource" + routeType + marker.id,
          layout: {},
          paint: {
            "circle-color": "brown",
            "circle-opacity": 0.2,
            "circle-radius": {
              type: "exponential",
              base: 1.5,
              stops: [
                //I actually have no idea how this actually works, but the sizing seems decent, haha.
                [0, 1 * Math.pow(2, 9 - 13)], //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
                [24, 25 * Math.pow(2, 24 - 18)] //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
              ]
            },
            "circle-stroke-color": "brown",
            "circle-stroke-opacity": 1,
            "circle-stroke-width": 2,
            "circle-pitch-alignment": "map"
          }
        });
        //*** Add on click functionality here */
        this.map.on("click", "dangercircle" + routeType + marker.id, e => {
          this.map
            .getSource("dangersource" + routeType + marker.id)
            ._data.geometry.coordinates.map(coords => {
              console.log("e.lngLat", e.lngLat);
              console.log("coords", coords);
            });
          if (this.zoomed == false) {
            this.zoomed = true;
            this.map.flyTo({
              center: e.lngLat,
              bearing: 30,
              pitch: 45,
              zoom: 18,
              speed: 1.7 // make the flying slow
              // curve: 1, // change the speed at which it zooms out
            });
            //Turn on Satallite and Annotations Layers, if they are off

            if (
              this.map.getLayoutProperty("mapbox-satellite", "visibility") ===
              "none"
            ) {
              document.getElementById("satellite").click();
            }
            if (
              this.map.getLayoutProperty("road-label", "visibility") === "none"
            ) {
              document.getElementById("annotation").click();
            }
            //Geojson pathway route always appears as a layer *on top of* the map layers
            //so I need to turn the line-opacity down to 0.4, so you can read the street names
            //that appear undernearthe the bike
            for (let j = 1; j <= this.markerList.length - 1; j++) {
              this.map.setPaintProperty(
                this.markerList[j].id,
                "line-opacity",
                0.4
              );
            }
            e.stopPropagation();
          } else if (this.zoomed == true) {
            this.zoomed = false;
            this.zoomToFullRoute();
            if (
              this.map.getLayoutProperty("mapbox-satellite", "visibility") ===
              "visible"
            ) {
              document.getElementById("satellite").click();
            }
            //Shut off Annotations if they are on
            if (
              this.map.getLayoutProperty("road-label", "visibility") ===
              "visible"
            ) {
              document.getElementById("annotation").click();
            }
            for (let j = 1; j <= this.markerList.length - 1; j++) {
              this.map.setPaintProperty(
                this.markerList[j].id,
                "line-opacity",
                0.9
              );
            }

            e.stopPropagation();
          }
        });
        // Change the cursor to a pointer when the it enters a feature in the 'symbols' layer.
        this.map.on(
          "mouseenter",
          "dangercircle" + routeType + marker.id,
          () => {
            this.insideWarningBubble = true;
            this.map.getCanvas().style.cursor = "pointer";
          }
        );

        // Change it back to a pointer when it leaves.
        this.map.on(
          "mouseleave",
          "dangercircle" + routeType + marker.id,
          () => {
            this.insideWarningBubble = false;
            this.map.getCanvas().style.cursor = "";
          }
        );
      }, 500);
    },
    removeSpecificCirclesOnMap(marker) {
      //Only display the source that is currently active
      // let routeType = this.uiRouteType == "Safe" ? "safe" : "risky";

      //if and only if, map source exists, then remove the layers and the source...
      if (this.map.getSource("dangersource" + "risky" + marker.id)) {
        this.map.removeLayer("dangerdot" + "risky" + marker.id);
        this.map.removeLayer("dangercircle" + "risky" + marker.id);
        this.map.removeSource("dangersource" + "risky" + marker.id);
      }
      if (this.map.getSource("dangersource" + "safe" + marker.id)) {
        this.map.removeLayer("dangerdot" + "safe" + marker.id);
        this.map.removeLayer("dangercircle" + "safe" + marker.id);
        this.map.removeSource("dangersource" + "safe" + marker.id);
      }
    },
    updateAllTurfCircles() {
      //Only display the source that is currently active
      let routeType = this.uiRouteType == "Safe" ? "safe" : "risky";

      let markersWithRoutes = this.markerList.filter(
        e => this.markerList.indexOf(e) > 0
      );

      markersWithRoutes.map(marker => {
        this.map.addSource(
          "dangersource" + routeType + marker.id,
          marker.warning[routeType]
        );
        this.map.addLayer({
          id: "dangerdot" + routeType + marker.id,
          type: "circle",
          source: "dangersource" + routeType + marker.id,
          layout: {},
          paint: {
            "circle-color": "brown",
            "circle-opacity": 1,
            "circle-radius": {
              stops: [
                [0, 5 * Math.pow(2, 0 - 23.5)],
                [24, 5 * Math.pow(2, 24 - 23.5)]
                //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
                //set the line-width at different zooms,
                //specifically the minzoom and maxzoom. By using the exponential
                //type with base set to 2 the line width function should
                //interpolate between these zooms in a way that the line covers
                //the same geographic area as you zoom in and out.
              ]
            },
            "circle-stroke-color": "black",
            "circle-stroke-opacity": 1,
            "circle-stroke-width": 1,
            "circle-pitch-alignment": "map"
          }
        });
        //Add radial circle
        this.map.addLayer({
          id: "dangercircle" + routeType + marker.id,
          type: "circle",
          source: "dangersource" + routeType + marker.id,
          layout: {},
          paint: {
            "circle-color": "brown",
            "circle-opacity": 0.2,
            "circle-radius": {
              type: "exponential",
              base: 1.5,
              stops: [
                //I actually have no idea how this actually works, but the sizing seems decent, haha.
                [0, 1 * Math.pow(2, 9 - 13)], //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
                [24, 25 * Math.pow(2, 24 - 18)] //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
              ]
            },
            "circle-stroke-color": "brown",
            "circle-stroke-opacity": 1,
            "circle-stroke-width": 2,
            "circle-pitch-alignment": "map"
          }
        });
        //*** Add on click functionality here */
        this.map.on("click", "dangercircle" + routeType + marker.id, e => {
          var warningCircles = this.map.getSource(
            "dangersource" + routeType + marker.id
          )._data.geometry.coordinates;

          var mousePoint = turf.point([e.lngLat.lng, e.lngLat.lat]);
          var intermediatePoints = warningCircles.map(e => turf.point(e));
          var finalPoints = turf.featureCollection(intermediatePoints);
          var nearest = nearestPoint(mousePoint, finalPoints);
          var circleLngLat = {
            lng: nearest.geometry.coordinates[0],
            lat: nearest.geometry.coordinates[1]
          };

          if (this.zoomed == false) {
            this.zoomed = true;
            this.map.flyTo({
              center: circleLngLat,
              bearing: 30,
              pitch: 45,
              zoom: 18,
              speed: 1.7 // make the flying slow
              // curve: 1, // change the speed at which it zooms out
            });
            //Turn on Satallite and Annotations Layers, if they are off
            if (
              this.map.getLayoutProperty("mapbox-satellite", "visibility") ===
              "none"
            ) {
              document.getElementById("satellite").click();
            }
            if (
              this.map.getLayoutProperty("road-label", "visibility") === "none"
            ) {
              document.getElementById("annotation").click();
            }
            //Geojson pathway route always appears as a layer *on top of* the map layers
            //so I need to turn the line-opacity down to 0.4, so you can read the street names
            //that appear undernearthe the bike
            for (let j = 1; j <= this.markerList.length - 1; j++) {
              this.map.setPaintProperty(
                this.markerList[j].id,
                "line-opacity",
                0.4
              );
            }
            e.stopPropagation();
          } else if (this.zoomed == true) {
            this.zoomed = false;
            this.zoomToFullRoute();
            if (
              this.map.getLayoutProperty("mapbox-satellite", "visibility") ===
              "visible"
            ) {
              document.getElementById("satellite").click();
            }
            //Shut off Annotations if they are on
            if (
              this.map.getLayoutProperty("road-label", "visibility") ===
              "visible"
            ) {
              document.getElementById("annotation").click();
            }
            for (let j = 1; j <= this.markerList.length - 1; j++) {
              this.map.setPaintProperty(
                this.markerList[j].id,
                "line-opacity",
                0.9
              );
            }

            e.stopPropagation();
          }
        });
        // Change the cursor to a pointer when the it enters a feature in the 'symbols' layer.
        this.map.on(
          "mouseenter",
          "dangercircle" + routeType + marker.id,
          () => {
            this.insideWarningBubble = true;
            this.map.getCanvas().style.cursor = "pointer";
          }
        );

        // Change it back to a pointer when it leaves.
        this.map.on(
          "mouseleave",
          "dangercircle" + routeType + marker.id,
          () => {
            this.insideWarningBubble = false;
            if (this.mapMode == "freeDrawMode") {
              this.map.getCanvas().style.cursor = "crosshair";
            } else {
              this.map.getCanvas().style.cursor = "";
            }
          }
        );
      });
    },
    removeAllCirclesOnMap() {
      //Only display the source that is currently active
      // let routeType = this.uiRouteType == "Safe" ? "safe" : "risky";

      if (this.markerList[0].warning) {
        var markersWithRoutes = this.markerList;
      } else {
        markersWithRoutes = this.markerList.filter(
          e => this.markerList.indexOf(e) > 0
        );
      }

      markersWithRoutes.map(marker => {
        //if and only if, map source exists, then remove the layers and the source...
        if (this.map.getSource("dangersource" + "safe" + marker.id)) {
          this.map.removeLayer("dangerdot" + "safe" + marker.id);
          this.map.removeLayer("dangercircle" + "safe" + marker.id);
          this.map.removeSource("dangersource" + "safe" + marker.id);
        }
        if (this.map.getSource("dangersource" + "risky" + marker.id)) {
          this.map.removeLayer("dangerdot" + "risky" + marker.id);
          this.map.removeLayer("dangercircle" + "risky" + marker.id);
          this.map.removeSource("dangersource" + "risky" + marker.id);
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    toggleRefreshStats() {
      this.refreshStats = !this.refreshStats;
    },
    async calculateSafeRiskyCO2Routes(start, end, middle) {
      middle = middle || false;

      if (middle) {
        try {
          let AllRouteArray = [];
          let promise_safegeojson = this.safeRouteCalc(start, middle);
          let promise_dangerousgeojson = this.dangerousRouteCalc(start, middle);
          let promise_Co2geojson = this.CO2RouteCalc(start, middle);

          await Promise.all([
            promise_safegeojson,
            promise_dangerousgeojson,
            promise_Co2geojson
          ])
            .then(results => {
              AllRouteArray = results;
              // console.log(AllRouteArray);
            })
            .catch(error => {
              alert(
                "something went wrong in the route generation of the safe route, dangerous route, or CO2 Estimate"
              );
              console.error(error);
            });

          this.markerList.indexOf(middle);

          //Add geojsons to AllMarkers Array of Objects
          middle.gh.safe = AllRouteArray[0];
          middle.gh.risky = AllRouteArray[1];
          middle.gh.carCO2 = AllRouteArray[2];

          //Visualize Data On Screen
          // displayMarkerRoute(end);
          // routeInfo.Display(); //*** May not need this */
          // await calculateMarkerDangerZone(endMarker); //*** May not need this */
          // displayMarkerDangerZone(endMarker); //*** May not need this */
        } catch (err) {
          console.error(err);
        }

        try {
          let AllRouteArray = [];
          let promise_safegeojson = this.safeRouteCalc(middle, end);
          let promise_dangerousgeojson = this.dangerousRouteCalc(middle, end);
          let promise_Co2geojson = this.CO2RouteCalc(middle, end);

          await Promise.all([
            promise_safegeojson,
            promise_dangerousgeojson,
            promise_Co2geojson
          ])
            .then(results => {
              AllRouteArray = results;
              // console.log(AllRouteArray);
            })
            .catch(error => {
              alert(
                "something went wrong in the route generation of the safe route, dangerous route, or CO2 Estimate"
              );
              console.error(error);
            });

          this.markerList.indexOf(end);

          //Add geojsons to AllMarkers Array of Objects
          end.gh.safe = AllRouteArray[0];
          end.gh.risky = AllRouteArray[1];
          end.gh.carCO2 = AllRouteArray[2];

          //Visualize Data On Screen
          // displayMarkerRoute(end);
          // routeInfo.Display(); //*** May not need this */
          // await calculateMarkerDangerZone(endMarker); //*** May not need this */
          // displayMarkerDangerZone(endMarker); //*** May not need this */
        } catch (err) {
          console.error(err);
        }
      } else {
        try {
          let AllRouteArray = [];
          let promise_safegeojson = this.safeRouteCalc(start, end);
          let promise_dangerousgeojson = this.dangerousRouteCalc(start, end);
          let promise_Co2geojson = this.CO2RouteCalc(start, end);

          await Promise.all([
            promise_safegeojson,
            promise_dangerousgeojson,
            promise_Co2geojson
          ])
            .then(results => {
              AllRouteArray = results;
              // console.log(AllRouteArray);
            })
            .catch(error => {
              alert(
                "something went wrong in the route generation of the safe route, dangerous route, or CO2 Estimate"
              );
              console.error(error);
            });

          this.markerList.indexOf(end);

          //Add geojsons to AllMarkers Array of Objects
          end.gh.safe = AllRouteArray[0];
          end.gh.risky = AllRouteArray[1];
          end.gh.carCO2 = AllRouteArray[2];

          //Visualize Data On Screen
          // displayMarkerRoute(end);
          // routeInfo.Display(); //*** May not need this */
          // await calculateMarkerDangerZone(endMarker); //*** May not need this */
          // displayMarkerDangerZone(endMarker); //*** May not need this */
        } catch (err) {
          console.error("our error", err);
        }
      }
      this.refreshStats = !this.refreshStats;
    },
    safeRouteCalc(start, end, middle) {
      middle = middle || false;
      if (middle) {
        alert("calc safe route with middle marker existing");
      } else {
        let ghRouting = new GraphHopper(this.GHParameters.safe);
        delete ghRouting.vehicle;
        ghRouting.addPoint(
          new GHInput(start.getLngLat().lat, start.getLngLat().lng)
        );
        ghRouting.addPoint(
          new GHInput(end.getLngLat().lat, end.getLngLat().lng)
        );
        return ghRouting.doRequest();
      }
    },
    dangerousRouteCalc(start, end, middle) {
      middle = middle || false;
      if (middle) {
        alert("calc risky route with middle marker existing");
      } else {
        let ghRouting = new GraphHopper(this.GHParameters.risky);
        delete ghRouting.vehicle;
        ghRouting.addPoint(
          new GHInput(start.getLngLat().lat, start.getLngLat().lng)
        );
        ghRouting.addPoint(
          new GHInput(end.getLngLat().lat, end.getLngLat().lng)
        );
        return ghRouting.doRequest();
      }
    },
    CO2RouteCalc(start, end, middle) {
      middle = middle || false;
      if (middle) {
        alert("calc co2 route with middle marker existing");
      } else {
        let ghRouting = new GraphHopper(this.GHParameters.safe);
        delete ghRouting.vehicle;
        ghRouting.addPoint(
          new GHInput(start.getLngLat().lat, start.getLngLat().lng)
        );
        ghRouting.addPoint(
          new GHInput(end.getLngLat().lat, end.getLngLat().lng)
        );
        return ghRouting.doRequest();
      }
    },
    toggleMapBaseLayer(layer) {
      if (layer == "pathways") {
        if (this.layer) {
          alert(`remove ${layer}`);
          this.map.removeLayer(layer);
        } else {
          alert(`add ${layer}`);
          this.map.addLayer(layer);
        }
      }
    },
    dropFarmMarkers() {
      let localmarkets = [];
      localmarkets.businesses = farmersmarket.businesses.filter(
        e =>
          e.name != "Sprouts Farmers Market" && e.name != "Whole Foods Market"
      );

      if (this.activeLayers["farm"]) {
        localmarkets.businesses.map(e => {
          var el = document.createElement("svg");
          el.className = "yelp farm";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        localmarkets.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropVolunteerMarkers() {
      if (this.activeLayers["volunteer"]) {
        alert("volunteer opportunities coming soon!");
        // bikeshops.businesses.map(e => {
        //   var el = document.createElement("svg");
        //   el.className = "yelp volunteer";
        //   e.marker = new mapboxgl.Marker(el)
        //     .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
        //     .setPopup(
        //       new mapboxgl.Popup({ offset: 25 }) // add popups
        // .setHTML(
        //     "<h5>" +
        //       e.name +
        //       `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
        //       e.location.address1 +
        //       "</h6><p>" +
        //       e.display_phone +
        //       "</p>"
        //   )
        //     )
        //     .addTo(this.map);
        // });
      } else {
        // alert("remove volunteer opportunties");
        // bikeshops.businesses.map(e => {
        //   e.marker.remove();
        // });
      }
    },
    dropBikeShopMarkers() {
      if (this.activeLayers["bikeshops"]) {
        bikeshops.businesses.map(e => {
          var el = document.createElement("svg");
          el.className = "yelp bikeshops";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        bikeshops.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropMuseumMarkers() {
      if (this.activeLayers["museums"]) {
        museums.businesses.map(e => {
          var el = document.createElement("div");
          el.className = "yelp museums";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        museums.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropBarMarkers() {
      let barsFiltered = [];
      barsFiltered.businesses = bars.businesses.filter(
        e =>
          e.name != "Dave & Buster's" &&
          e.name != "Chili's" &&
          e.name != "Applebee's Grill + Bar"
      );
      if (this.activeLayers["bars"]) {
        barsFiltered.businesses.map(e => {
          var el = document.createElement("div");
          el.className = "yelp bars";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        barsFiltered.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropRestaurantMarkers() {
      if (this.activeLayers["restaurants"]) {
        restaurants.businesses.map(e => {
          var el = document.createElement("div");
          el.className = "yelp restaurants";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        restaurants.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropBreweryMarkers() {
      if (this.activeLayers["breweries"]) {
        breweries.businesses.map(e => {
          var el = document.createElement("div");
          el.className = "yelp breweries";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        breweries.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    dropCoffeeMarkers() {
      let cafe = [];
      cafe.businesses = coffee.businesses.filter(
        e =>
          e.name != "Starbucks" &&
          e.name != "McDonald's" &&
          e.name != "Circle K" &&
          e.name != "Subway" &&
          e.name != "7-Eleven" &&
          e.name != "Dunkin'" &&
          e.name != "Dunkin" &&
          e.name != "Dutch Bros Coffee" &&
          e.name != "Speedway"
      );
      if (this.activeLayers["coffee"]) {
        cafe.businesses.map(e => {
          var el = document.createElement("div");
          el.className = "yelp coffee";
          e.marker = new mapboxgl.Marker(el)
            .setLngLat([e.coordinates.longitude, e.coordinates.latitude])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML(
                  "<h5>" +
                    e.name +
                    `</h5><a href=${e.url}><img src=${e.image_url}></a><h6><br>` +
                    e.location.address1 +
                    "</h6><p>" +
                    e.display_phone +
                    "</p>"
                )
            )
            .addTo(this.map);
        });
      } else {
        cafe.businesses.map(e => {
          e.marker.remove();
        });
      }
    },
    searchedDirections() {
      this.clearMap();
      this.geolocate.trigger();

      setTimeout(async () => {
        //Design the Marker
        this.geolocateMarker = new mapboxgl.Marker({
          draggable: true,
          color: "orange", //'#363636',
          scale: 0.8
        });

        this.geolocateMarker.setLngLat([
          this.geolocate._lastKnownPosition.coords.longitude,
          this.geolocate._lastKnownPosition.coords.latitude
        ]);
        this.geolocateMarker.addTo(this.map);

        //As the Marker is being moved, do not allow Graphhopper to calculate routes
        this.geolocateMarker
          .on("dragstart", () => {
            this.localMapIsStatic = false;
            this.currentMarker = this.determinePosition(this.geolocateMarker);
          })
          .on("dragend", async () => {
            this.localMapIsStatic = true;
            var index = this.markerList.indexOf(this.geolocateMarker);
            this.currentMarker = this.determinePosition(this.geolocateMarker);
            if (this.currentMarker == "solo") {
              return;
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              var nextMarker = this.markerList[index + 1];
              this.removeSpecificCirclesOnMap(nextMarker);
              await this.calculateSafeRiskyCO2Routes(
                this.geolocateMarker,
                nextMarker
              );
              this.displayRoute(nextMarker);
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(this.geolocateMarker.id);
              this.map.removeSource(this.geolocateMarker.source);
              var previousMarker = this.markerList[index - 1];
              this.removeSpecificCirclesOnMap(this.currentMarker);
              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                this.geolocateMarker
              );
              this.displayRoute(this.geolocateMarker);
            } else if (this.currentMarker == "middle") {
              this.map.removeLayer(this.geolocateMarker.id);
              this.map.removeSource(this.geolocateMarker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(this.geolocateMarker);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              previousMarker = this.markerList[index - 1];
              nextMarker = this.markerList[index + 1];
              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker, //*IOU - investigate if this code would ever happen, geolocate can only ever be solo or first, correct?
                this.geolocateMarker
              );
            }
          })
          .getElement()
          .addEventListener("click", async e => {
            this.geolocateMarker.remove(); //Remove the Marker from the Map
            e.stopPropagation();
            var index = this.markerList.indexOf(this.geolocateMarker);
            this.currentMarker = this.determinePosition(this.geolocateMarker);
            if (this.currentMarker == "solo") {
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(this.geolocateMarker.id);
              this.map.removeSource(this.geolocateMarker.source);
              this.removeSpecificCirclesOnMap(this.currentMarker); //this might be wrong ***
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "middle") {
              this.map.removeLayer(this.geolocateMarker.id);
              this.map.removeSource(this.geolocateMarker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(this.geolocateMarker);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              var previousMarker = this.markerList[index - 1];
              var nextMarker = this.markerList[index + 1];
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;

              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker
              );
              this.displayRoute(nextMarker); //*IOU - investigate if this code would ever happen, geolocate can only ever be solo or first, correct?
            }
          });

        //Add Unique ID to marker object
        this.geolocateMarker.id = `marker${this.uniquePOIKey}`;
        this.geolocateMarker.source = `source${this.uniquePOIKey}`;
        this.geolocateMarker.gh = {};
        this.uniquePOIKey += 1;
        this.markerList.push(this.geolocateMarker);
        this.currentMarker = this.determinePosition(this.geolocateMarker);

        //Design the Marker
        let endMarker = new mapboxgl.Marker({
          draggable: true,
          color: "blue", //'#363636',
          scale: 0.8
        });

        endMarker.setLngLat(this.geocoder.mapMarker.getLngLat());
        endMarker.gh = {};
        endMarker.addTo(this.map);

        //As the Marker is being moved, do not allow Graphhopper to calculate routes
        endMarker
          .on("dragstart", () => {
            this.localMapIsStatic = false;
            this.currentMarker = this.determinePosition(endMarker);
          })
          .on("dragend", async () => {
            this.localMapIsStatic = true;
            var index = this.markerList.indexOf(endMarker);
            this.currentMarker = this.determinePosition(endMarker);
            if (this.currentMarker == "solo") {
              return;
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              var nextMarker = this.markerList[index + 1];
              await this.calculateSafeRiskyCO2Routes(endMarker, nextMarker);
              this.displayRoute(nextMarker);
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(endMarker.id);
              this.map.removeSource(endMarker.source);
              this.removeSpecificCirclesOnMap(endMarker);
              var previousMarker = this.markerList[index - 1];
              await this.calculateSafeRiskyCO2Routes(previousMarker, endMarker);
              this.displayRoute(endMarker);
            } else if (this.currentMarker == "middle") {
              this.map.removeLayer(endMarker.id);
              this.map.removeSource(endMarker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(endMarker);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              previousMarker = this.markerList[index - 1];
              nextMarker = this.markerList[index + 1];
              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker,
                endMarker
              );
              this.displayRoute(endMarker);
              this.displayRoute(nextMarker);
            }
          })
          .getElement()
          .addEventListener("click", async e => {
            endMarker.remove(); //Remove the Marker from the Map
            e.stopPropagation();
            var index = this.markerList.indexOf(endMarker);
            this.currentMarker = this.determinePosition(endMarker);
            if (this.currentMarker == "solo") {
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(endMarker.id);
              this.map.removeSource(endMarker.source);
              this.removeSpecificCirclesOnMap(endMarker);
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
            } else if (this.currentMarker == "middle") {
              this.map.removeLayer(endMarker.id);
              this.map.removeSource(endMarker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.removeSpecificCirclesOnMap(endMarker);
              this.removeSpecificCirclesOnMap(this.markerList[index + 1]);
              var previousMarker = this.markerList[index - 1];
              var nextMarker = this.markerList[index + 1];
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;

              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker
              );
              this.displayRoute(nextMarker);
            }
          });

        //Add Unique ID to marker object
        endMarker.id = `marker${this.uniquePOIKey}`;
        endMarker.source = `source${this.uniquePOIKey}`;
        this.uniquePOIKey += 1;
        this.markerList.push(endMarker);

        await this.calculateSafeRiskyCO2Routes(this.geolocateMarker, endMarker);
        this.displayRoute(endMarker);
        this.geocoder.clear();
        document
          .getElementsByClassName("mapboxgl-ctrl-geocoder--input")[0]
          .blur();

        setTimeout(() => {
          let safeOrRisky = this.uiRouteType == "Safe" ? "safe" : "risky";
          console.log(this.markerList[1].gh[safeOrRisky].paths[0].bbox);
          this.markerList[1].gh[safeOrRisky].paths[0].bbox[0] =
            this.markerList[1].gh[safeOrRisky].paths[0].bbox[0] - 0.01;
          this.markerList[1].gh[safeOrRisky].paths[0].bbox[1] =
            this.markerList[1].gh[safeOrRisky].paths[0].bbox[1] - 0.01;
          this.markerList[1].gh[safeOrRisky].paths[0].bbox[2] =
            this.markerList[1].gh[safeOrRisky].paths[0].bbox[2] + 0.01;
          this.markerList[1].gh[safeOrRisky].paths[0].bbox[3] =
            this.markerList[1].gh[safeOrRisky].paths[0].bbox[3] + 0.01;
          this.map.fitBounds(this.markerList[1].gh[safeOrRisky].paths[0].bbox);
        }, 1000);
      }, 1000);
    },
    clearMap() {
      let markerListWithRoutes = this.markerList.slice(1);

      if (this.markerList.length >= 1) {
        this.markerList[0].remove(); //Remove first marker from map
      }
      //For the remaining markerlist, if any, remove the marker, and their associated route
      if (this.markerList.length >= 2) {
        markerListWithRoutes.map(e => {
          e.remove();
          this.map.removeLayer(e.id);
          this.map.removeSource(e.source);
        });
      }
      this.markerList = [];
    },
    toggleSafeRouting() {
      // alert(
      //   "toggleSafeRouting should now\r\n1. Check state.uiRouteType if it is safe or traditional. \r\n2. run a removeLayer command \r\n3. run an addLayer Command \r\n4. Do that over a .map(e => ...) through all the list of markers"
      // );
      this.markerList.map(e => {
        var index = this.markerList.indexOf(e);
        if (index != 0) {
          this.map.removeLayer(e.id);
          this.map.removeSource(e.source);
          this.displayRoute(e);
        }
      });

      // this.markerList.map(e => {
      //   var index = this.markerList.indexOf(e);
      //   if (index != 0) {
      //     this.map.removeLayer(e.id);
      //     this.map.removeSource(e.source);
      //     this.calculateSafeRiskyCO2Routes(this.markerList[index - 1], e);
      //   }
      // });
    },
    undoLastMarker() {
      var marker = this.markerList[this.markerList.length - 1];
      var index = this.markerList.indexOf(marker);
      marker.remove();
      this.markerList.splice(index, 1);
      if (index > 0) {
        this.map.removeLayer(marker.id);
        this.map.removeSource(marker.source);
        this.removeSpecificCirclesOnMap(marker);

        this.refreshStats = !this.refreshStats;
      }
    },
    removeMarkerRoute(marker) {
      this.currentMarker = this.determinePosition(marker);
      var index = this.markerList.indexOf(marker);
      if (this.currentMarker == "solo") {
        return;
      } else if (this.currentMarker == "first") {
        this.map.removeLayer(this.markerList[index + 1].id);
        this.map.removeSource(this.markerList[index + 1].source);
      } else if (this.currentMarker == "last") {
        this.map.removeLayer(marker.id);
        this.map.removeSource(marker.source);
      } else if (this.currentMarker == "middle") {
        this.map.removeLayer(this.markerList[index + 1].id);
        this.map.removeSource(this.markerList[index + 1].source);
        this.map.removeLayer(this.markerList[index].id);
        this.map.removeSource(this.markerList[index].source);
      }
    },
    async generateRouteAsync(start, end, middle) {
      middle = middle || false;

      this.ghRouting =
        this.uiRouteType == "Safe"
          ? new GraphHopper(this.GHParameters.safe)
          : new GraphHopper(this.GHParameters.risky);

      delete this.ghRouting.vehicle;

      if (middle) {
        //Start to Middle Route
        this.ghRouting.addPoint(
          new GHInput(start.getLngLat().lat, start.getLngLat().lng)
        );
        this.ghRouting.addPoint(
          new GHInput(middle.getLngLat().lat, middle.getLngLat().lng)
        );

        try {
          var route = await this.ghRouting.doRequest();
          alert(`I need to find where I'm suppose to use ${route}.`);
          await this.displayRoute(middle);
        } catch (err) {
          alert(`Async Route Generation Errored Out =(\r\n\r\n${err.message}`);
          console.error(err.message);
          middle.remove();
          var index = this.markerList.indexOf(middle);
          this.markerList.splice(index, 1);
        }

        this.ghRouting.addPoint(
          new GHInput(middle.getLngLat().lat, middle.getLngLat().lng)
        );
        this.ghRouting.addPoint(
          new GHInput(end.getLngLat().lat, end.getLngLat().lng)
        );

        try {
          route = await this.ghRouting.doRequest();
          await this.displayRoute(end);
        } catch (err) {
          alert(`Async Route Generation Errored Out =(\r\n\r\n${err.message}`);
          console.error(err.message);
          end.remove();
          index = this.markerList.indexOf(end);
          this.markerList.splice(index, 1);
        }
      } else {
        //Middle doesn't exist -- easy peasy start/end route generation and link route to end
        console.log(`GH Start:`, start.getLngLat().lat, start.getLngLat().lng);
        console.log(`GH End:`, end.getLngLat().lat, end.getLngLat().lng);

        this.ghRouting.addPoint(
          new GHInput(start.getLngLat().lat, start.getLngLat().lng)
        );
        this.ghRouting.addPoint(
          new GHInput(end.getLngLat().lat, end.getLngLat().lng)
        );

        try {
          route = await this.ghRouting.doRequest();
          await this.displayRoute(end); //*** I dont think I need this await here */
        } catch (err) {
          alert(`Async Route Generation Errored Out =(\r\n\r\n${err.message}`);
          console.error(err.message);
          end.remove();
          index = this.markerList.indexOf(end);
          this.markerList.splice(index, 1);
        }
      }
    },
    determinePosition(marker) {
      var index = this.markerList.indexOf(marker);
      var maxIndex = this.markerList.length - 1;
      if (maxIndex < 1 && index == maxIndex) {
        //There is only one POI on screen, which was moved -- No need to generate route
        return "solo";
      }
      if (maxIndex >= 1 && index == 0) {
        //The very 1st POI was moved
        return "first";
      }
      if (maxIndex >= 1 && index == maxIndex) {
        //The very last POI was moved
        return "last";
      }
      if (maxIndex >= 1 && index > 0 && index != maxIndex) {
        //A middle POI was moved
        return "middle";
      }
    },
    displayRoute(marker) {
      var idName = marker.id;
      var sourceName = marker.source;
      var routeCoordinates =
        this.uiRouteType == "Safe"
          ? marker.gh.safe.paths[0].points
          : marker.gh.risky.paths[0].points;

      this.map.addSource(sourceName, {
        type: "geojson",
        data: {
          type: "Feature",
          properties: {},
          geometry: routeCoordinates
        }
      });

      this.map.addLayer({
        id: idName,
        type: "line",
        source: sourceName,
        paint: {
          "line-color": this.linecolor, //"#1c4358", //pathwayscolor //"#FF6600" //, //"#4f7ba4",
          // "line-dasharray": [2,1.5], //[dashes, gaps] measured in units of line-width
          "line-opacity": 0.9,
          "line-width": {
            type: "exponential",
            base: 1.5,
            stops: [
              [0, 4.5 * Math.pow(2, 0 - 9)], //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
              [24, 4.5 * Math.pow(2, 24 - 18)] //[0, baseWidth * Math.pow(2, (0 - baseZoom))],
            ]
          }
        }
      });
    },
    toggleFreeDrawMode: function() {
      if (this.mapMode === "freeDrawMode") {
        this.toggleCrosshair();
        this.map.on("click", this.mapDropMarker);
      } else {
        this.toggleCrosshair();
        this.map.off("click", this.mapDropMarker);
      }
    },
    toggleCrosshair: function() {
      if (this.mapMode === "crosshairMode") {
        this.centerdot = new mapboxgl.Marker({
          draggable: false,
          color: "brown", //'#363636',un
          scale: 0.8
        })
          .setLngLat(this.map.getCenter())
          .addTo(this.map);
      } else {
        this.centerdot.remove();
      }
    },
    initializeMap: function() {
      const mapContainer = this.$refs.mapboxMap;

      mapboxgl.accessToken = this.mapboxAPIKey;
      this.map = new mapboxgl.Map({
        container: mapContainer, // container id
        style: "mapbox://styles/dylanc/ckcb3lu6f0lsq1ioatvd4im5m",
        center: this.mapCenter,
        zoom: this.mapZoom,
        pitch: 0, //pitch: 45,
        bearing: 0, //bearing: 10,
        attributionControl: false, // Removed default attribution and put custom attribution in below
        maxBounds: [
          [-111.2, 32],
          [-110.6, 32.5]
        ], //Southwest & Northeast Bounds
        minZoom: 12
      });

      this.map.on("move", () => {
        this.localMapIsStatic = false;
      });

      this.map.on("moveend", () => {
        this.localMapIsStatic = true;
      });

      //Add Mapbox Search Box
      this.geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: {
          color: "teal"
        },
        placeholder: "Where to?",
        bbox: [-111.2, 32, -110.6, 32.5]
      });
      this.map.addControl(this.geocoder, "top-left");

      this.geocoder.on("result", () => {
        // this.mapMode = "geocoderMode";
        this.geocoderData.locationName = this.geocoder._typeahead.selected.text;
        this.$store.commit("toggleStateMapMode", "searchMode");
        document.activeElement.blur(); //I want the keyboard to close after search on mobile. Removing focus from input searchbar will do that.
      });

      //Add Geolocate Control To Find User Position
      this.geolocate = new mapboxgl.GeolocateControl(this.geolocateSettings);
      this.map.addControl(this.geolocate);

      let vm = this;
      this.geolocate.on("geolocate", e => {
        vm.geolocatePosition.lng = e.coords.longitude;
        vm.geolocatePosition.lat = e.coords.latitude;
        console.log("vue geolocation data", vm.geolocatePosition);
      });

      this.geolocate.on("outofmaxbounds", function() {
        alert(
          "uh oh spaghettios!\r\n\r\nI'm afraid your current location is outside of the Tucson Metro!\r\n\r\nSo Geolocation based routing will not work for you!"
        );
      });

      //Add Zoom & Rotation Controls
      const zoom = new mapboxgl.NavigationControl({
        accessToken: this.mapboxAPIKey,
        showZoom: false
      });
      this.map.addControl(zoom);

      //Shrinks Attribution to a small hover icon for displays 640px or less
      this.map.addControl(
        new mapboxgl.AttributionControl({
          compact: true
        })
      );

      this.map.on("styledata", () => {
        if (!this.mapIsReady) {
          this.mapIsReady = true;
        }
      });

      this.map
        .on("moveend", () => {
          this.mapCenter = this.map.getCenter();
          this.mapZoom = this.map.getZoom();
        })
        .on("move", () => {
          // eslint-disable-next-line prettier/prettier
          if (this.centerdot) {
            //Alternative logic statement --- if (typeof vm.centerdot !== "undefined") {
            this.centerdot.setLngLat(this.map.getCenter());
          }
        });
    },
    mapDropMarker: async function(e) {
      if (this.insideWarningBubble == false) {
        //Design the Marker
        let marker = new mapboxgl.Marker({
          draggable: true,
          color: "grey", //'#363636',
          scale: 0.8
        });

        //Add Marker to Map
        this.mapMode === "crosshairMode"
          ? marker.setLngLat(this.map.getCenter())
          : this.mapMode === "freeDrawMode"
          ? marker.setLngLat(e.lngLat)
          : alert("this is where geocoder mode goes");

        marker.addTo(this.map);

        //As the Marker is being moved, do not allow Graphhopper to calculate routes
        marker
          .on("dragstart", () => {
            this.localMapIsStatic = false;
            this.currentMarker = this.determinePosition(marker);
          })
          .on("dragend", async () => {
            this.localMapIsStatic = true;
            var index = this.markerList.indexOf(marker);
            this.currentMarker = this.determinePosition(marker);
            if (this.currentMarker == "solo") {
              return;
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              var nextMarker = this.markerList[index + 1];
              await this.calculateSafeRiskyCO2Routes(marker, nextMarker);
              this.displayRoute(nextMarker);
              this.removeSpecificCirclesOnMap(nextMarker);
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(marker.id);
              this.map.removeSource(marker.source);
              var previousMarker = this.markerList[index - 1];
              await this.calculateSafeRiskyCO2Routes(previousMarker, marker);
              this.displayRoute(marker);
              this.removeSpecificCirclesOnMap(marker);
            } else if (this.currentMarker == "middle") {
              this.map.removeLayer(marker.id);
              this.map.removeSource(marker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              previousMarker = this.markerList[index - 1];
              nextMarker = this.markerList[index + 1];
              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker,
                marker
              );
              this.removeSpecificCirclesOnMap(nextMarker);
              this.removeSpecificCirclesOnMap(marker);
              this.displayRoute(nextMarker);
              this.displayRoute(marker);
              // this.displaySpecificCirclesOnMap(marker);
              // this.displaySpecificCirclesOnMap(nextMarker);
            }
          })
          .getElement()
          .addEventListener("click", async e => {
            marker.remove(); //Remove the Marker from the Map
            e.stopPropagation();
            var index = this.markerList.indexOf(marker);
            this.currentMarker = this.determinePosition(marker);
            if (this.currentMarker == "solo") {
              this.markerList.splice(index, 1);
            } else if (this.currentMarker == "first") {
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
              this.removeSpecificCirclesOnMap(this.currentMarker);
              // this.displaySpecificCirclesOnMap(this.currentMarker);
            } else if (this.currentMarker == "last") {
              this.map.removeLayer(marker.id);
              this.map.removeSource(marker.source);
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
              this.removeSpecificCirclesOnMap(marker);
            } else if (this.currentMarker == "middle") {
              var nextMarker = this.markerList[index + 1];
              this.map.removeLayer(marker.id);
              this.map.removeSource(marker.source);
              this.map.removeLayer(this.markerList[index + 1].id);
              this.map.removeSource(this.markerList[index + 1].source);
              var previousMarker = this.markerList[index - 1];
              this.markerList.splice(index, 1);
              this.refreshStats = !this.refreshStats;
              this.removeSpecificCirclesOnMap(marker);
              this.removeSpecificCirclesOnMap(nextMarker);

              await this.calculateSafeRiskyCO2Routes(
                previousMarker,
                nextMarker
              );
              this.displayRoute(nextMarker);
              // this.displaySpecificCirclesOnMap(nextMarker);
            }
          });

        //Add Unique ID to marker object
        marker.id = `marker${this.uniquePOIKey}`;
        marker.source = `source${this.uniquePOIKey}`;
        this.uniquePOIKey += 1;
        this.markerList.push(marker);
        this.currentMarker = this.determinePosition(marker);
        var index = this.markerList.indexOf(marker);

        if (this.currentMarker == "last") {
          marker.gh = {};
          await this.calculateSafeRiskyCO2Routes(
            this.markerList[index - 1],
            marker
          );

          this.displayRoute(marker);
          // this.displaySpecificCirclesOnMap(marker);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
}
#mapboxCanvas {
  position: absolute;
  // top: 38.5px;
  // z-index: -1;
  top: 44px;
  width: 100vw;
  border: none; /*solid 2px black;*/
  bottom: 12vh;
}

#logo {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  position: absolute;
  z-index: 3;
  max-width: 80px;
  max-height: 80px;
  left: 10px;
  background: #363636;
  width: 14vw;
  height: 14vw;
  font-size: 2.5em;
  line-height: 2.5em;
  color: white;
  text-align: center;
  font-family: auto;
  // box-shadow: 3px 3px 6px grey;
}
</style>
